import React from "react";
//Kendo Imports
import {
    Chart,
    ChartArea,
    ChartSeries,
    ChartSeriesItem,
    ChartCategoryAxis,
    ChartCategoryAxisTitle,
    ChartCategoryAxisItem,
    ChartLegend,
    ChartValueAxis,
    ChartValueAxisItem,
    ChartTooltip,
    ChartCategoryAxisLabels
} from "@progress/kendo-react-charts";
import { Grid, GridColumn as Column } from "@progress/kendo-react-grid";

const PoleUndergroundChart = ({ totalRejectCat, percentRejectCat, totalRejectCount, totalRejectPercent, predictiveCategories, predictiveChartData, inspectionType,
    rejectExt, rejectInt, rejectIntX, rejectExtX, rejectReaX,rejectReaY }) => {
    //util states
    const [page, setPage] = React.useState({ skip: 0, take: 5 });

    function pageChange(event) {
        const targetEvent = event.targetEvent;
        const take = targetEvent.value === "All" ? inspectionType.length : event.page.take;
        setPage({
            ...event.page,
            take,
        });
    };

    //graph component for total reject
    //is count is a bool true for the count graph, false for the percent
    function TotalRejectComponent({type}) {
        return (
            <Chart>
                <ChartArea height={300} />
                <ChartTooltip />
                <ChartCategoryAxis>
                    <ChartCategoryAxisItem categories={type == "Int" ? rejectIntX : rejectExtX}>
                        {/* <ChartCategoryAxisTitle text="Reject Reason" /> */}
                        <ChartCategoryAxisLabels rotation={25} /> 
                    </ChartCategoryAxisItem>
                </ChartCategoryAxis>
                <ChartValueAxis>
                    <ChartValueAxisItem
                    />
                </ChartValueAxis>
                <ChartSeries>
                    <ChartSeriesItem
                        type="column"
                        data={type == "Int" ? rejectInt : rejectExt}
                        color="#4285f4"
                        tooltip={{ visible: true }}
                    />
                </ChartSeries>
            </Chart>
        );
    }

        function TotalRejectREason({type}) {
        return (
            <Chart>
                <ChartArea height={300} />
                <ChartTooltip />
                <ChartCategoryAxis>
                    <ChartCategoryAxisItem categories={rejectReaX}>
                        {/* <ChartCategoryAxisTitle text="Reject Reason" /> */}
                        <ChartCategoryAxisLabels rotation={25} /> 
                    </ChartCategoryAxisItem>
                </ChartCategoryAxis>
                <ChartValueAxis>
                    <ChartValueAxisItem
                    />
                </ChartValueAxis>
                <ChartSeries>
                    <ChartSeriesItem
                        type="column"
                        data={rejectReaY}
                        color="#4285f4"
                        tooltip={{ visible: true }}
                    />
                </ChartSeries>
            </Chart>
        );
    }

    return (
        <>
            <div className="chart-section">
                <p className="pulse-chart-title">Total # of Reject Internal</p>
                <div className="pulse-chart-container">
                    <TotalRejectComponent type={"Int"} />
                </div>
            </div>

            {/* Total Reject Poles (Percentage) */}
            <div className="chart-section">
                <p className="pulse-chart-title">Total # of Reject External</p>
                <div className="pulse-chart-container">
                    <TotalRejectComponent type={"Ext"} />
                </div>
            </div>

            {/* Inspection Type (Percentages and Quantities/Counts) */}
            <div className="chart-section">
                <p className="pulse-chart-title">Inspection Types</p>
                <div className="pulse-chart-container">
                    <TotalRejectREason type={"Reason"} />
                </div>
            </div>

        </>
    );
}

export default PoleUndergroundChart;